import axios from 'axios'

const actions = {
  fetchSliderList ({ rootGetters }, meta) {
    const params = `?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`

    return axios
      .get(`${rootGetters['api/sliderList']}${params}`).then(res => {
        return res
      })
      .catch(err => err)
  },
  fetchSingleSlider ({ rootGetters }, id) {
    return axios
      .get(rootGetters['api/sliderSingle'](id)).then(res => {
        return res
      }).catch(err => err)
  },
  createSlider ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/sliderCreate'], data).then(res => {
        return res
      })
      .catch(err => err)
  },
  editSlider ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/sliderEdit'](id), data).then(res => {
        return res
      })
      .catch(err => err)
  },
  removeSlider ({ rootGetters }, id) {
    return axios
      .delete(rootGetters['api/sliderDelete'](id)).then(res => {
        return res
      })
      .catch(err => err)
  },
}

export default {
  namespaced: true,
  actions,
}
